import { environment } from '../../environment';

export default async function callStoryblokApi<ReturnType>(path: string, queryParams?: object): Promise<ReturnType> {
  const url = new URL(path, environment.storyblokApi);

  url.searchParams.append('token', environment.storyblokApiAccessToken || '');
  url.searchParams.append('version', environment.storyblokVersion);

  if (queryParams) {
    Object.entries(queryParams).forEach(([key, value]) => url.searchParams.append(key, value));
  }

  const response = await fetch(url);
  return response.json();
}
